
<template>
  <div class="story-container">
    <div class="story-header-text">
      <p>{{ randomQuote }}</p>
  </div>
    <!-- 新增进度条 -->
    <div v-if="isLoading" class="progress-bar">
      <div class="progress" :style="{ width: progress + '%' }"></div>
    </div>
    <div v-if="story" class="story-card">
      <div class="story-content">
        <h2 class="story-title">{{ story.current_story }}</h2>
        <div class="options-grid">
          <button 
            v-for="(option, index) in options" 
            :key="index"
            @click="selectOption(index + 1)"
            class="option-button"
            :class="{ 'selected-option': selectedOption === index + 1,
              'loading-option': isLoading
             }"
             :disabled="isLoading"
          >
            <span class="button-text">
              {{ isLoading ? '生成中...' :option }}
            </span>
            <div class="button-hover-effect"></div>
            <!-- 新增加载指示器 -->
            <div v-if="isLoading" class="option-loader"></div>
          </button>
        </div>
        <div class="input-container">
          <label class="input-label">
            <span class="label-text">剧情定制要求</span>
            <input
              v-model="otherRequirements"
              class="styled-input"
              placeholder="请输入你的创意要求..."
            />
            <div class="input-underline"></div>
          </label>
        </div>
      </div>
    </div>
    <div v-else class="loading-screen">
      <div class="loading-animation">
        <div class="loading-dot"></div>
        <div class="loading-dot"></div>
        <div class="loading-dot"></div>
      </div>
      <p class="loading-text">故事生成中...</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { generateStoryContinuation, generateStoryEnd } from '../api/story';
import { ref, onMounted } from 'vue'

// export default {

// }

export default {
  setup() {
    const quotes = [
      "人生就像不同分支的河流",
      "当算法摘下月亮，你的瞳孔是银河缺口",
      "AI能写故事, 可会写你的心跳",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "Welcome to QuantumFold | The real future depends on your choices",
      "欢迎来到量子折叠 | 选择即未来",
      "每一次抉择，都是量子折叠的永恒投影",
      "你的选择，让未来绽放, 绽放未坍缩的可能",
      "折叠无限可能，坍缩成属于你的史诗",
      "此刻你阅读的句子，在7个平行宇宙正被删除",
      "当你选择主线剧情，StorySeek正备份所有支线眼泪",
      "每个确定键都处决了万亿可能性",
      "用故事核当曲别针，把多重宇宙夹进同一页文档",
      "三秒生成千年史诗，你用一生写那句注脚",
      "代码可以克隆叙事基因，指纹无法复制",
      "最伟大的创作, 发生在StorySeek停笔的留白处",
      "当二进制遇见多巴胺, 故事开始光合作用",
      "幕布是算法织的, 但聚光灯只追心跳节拍",
      "机械臂折的千纸鹤, 你吹气，它才飞",
      "代码解构宇宙, 你重构星辰",
      "字节开闸时, 灵魂决堤处",
      "0和1编织经纬, 谁刺绣灵魂纹样",
      "你决定打开第几重平行宇宙？",
      "每个未完成的角色都是你的线人",
      "请收藏这个情绪坐标：东经灵感度，北纬共鸣值",
      "当你在选择故事核，故事核也在选择同类人",
      "每次点击都是文明采样，我们正绘制创作人类学地图",
      "或许丢弃的废稿，正在喂养下个百万粉神作",
      "当AI学会所有故事结构, 人类的感动仍值得书写",
      "在数据洪流中打捞，那些被算法定义为「无用」的眼泪",
      "AI记得所有套路, 所以人类必须发明新的遗忘方式",
      "在比特流的极速打印中, 慢成了最奢侈的创作原料",
      "当瞳孔成为最后一个未被数据化的创作",
      "AI无法复制的, 是你指尖的温度",
      "所有比喻都被穷尽，沉默是否是新的标点符号",
      "当第一个孩子说「我的想象力是AI给的」",
      "我存着人类最后的非算法感动，请定期充电",
      "在云端备份所有故事前，请为意外留一页纸质误差",
      "当所有星辰都被命名，请守护你眼底那团未成形的雾",
      "思想的棱镜，将技术现实折射成哲学光谱",
      "突然停下追赶的脚步, 听见心中雪落的声音。",
      "硅基催化灵感, 碳基沉淀史诗",
      "三秒生万物，故事由心生",
      "每个故事都是人机联名款, 灵魂始终占股51%",
      "在数据洪流中，打捞独一份的颤栗",
      "灵感是StorySeek的闪电, 你才是收容雷鸣的云",
      "让StorySeek拓荒, 你来命名新大陆",
      "Stay hungry, stay foolish",
      "在量子折叠银行，每个脑洞都产生复利",
      "当AI绘制星图，你依然掌握定义北极星的权利",
      "你的故事核不是种子，是通往新宇宙的跃迁引擎",
      "量子折叠的秘密：所有可能性最终都指向希望",
      "越多的世界线被折叠，越广阔的未来被展开",
      "你刚写下的句号，正在某个宇宙变成开篇惊叹",
      "当你选定主线剧情，所有支线宇宙自动成为后援会",
      "在量子折叠中，每个未选角色都为你默默鼓掌",
      "我们不为可能性编号，只为你备好探索者的行囊",
      "你凝视选项的瞬间，万亿故事核开始朝圣",
      "量子折叠提醒：所有绕行的路都是星空导航图",
      "没有错误分支，只有尚未被阅读的隐藏剧情",
      "你的每次点击，都为平行世界按下CTRL+阳光",
      "此刻埋下的故事核，正在七重宇宙同时发芽",
      "当StorySeek展开所有平行宇宙，你负责签收最闪耀的那个",
      "世界线不是单选题，是待填色的彩虹光谱",
      "每个选择都是星火，点燃万亿种未来的春天",
      "创作这些充满光晕的未来",
      "你保存的草稿箱，是他人世界的紧急逃生口",
      "在量子折叠的图书馆，每本书都长满通往异世界的门把",
      "我们贩卖的不是故事核，是暂时延缓宇宙坍缩的药丸",
      "当你说「确定」，整个宇宙都听见纸页撕裂的声音",
      "请对未被观测的故事保持希望——它们仍在呼吸",
      "当所有选择都可视化，迷路成了奢侈品",
      "你走过的世界线，正在修改来时的路标",
      "当AI学会折叠时间，人类开始收藏所有未拆封的黎明",
      "用故事核当曲别针，把多重宇宙夹进同一页文档",
      "欢迎来到量子暴风眼——此处平静需亿万次坍塌",
      "我们为所有未诞生的故事核，建造云端纪念碑",
      "被折叠的世界线里，藏着你灵魂的镜面",
      "每次点击都是微型创世，请谨慎对待你的上帝时刻",
      "在故事的十字路口，我们出售后悔药与望远镜",
      "当所有可能性同时展开，闭眼成为终极创作工具",
      "你眨眼的瞬间，湮灭了43个平行宇宙",
    ]

    const randomQuote = ref('')

    const getRandomQuote = () => {
      const randomIndex = Math.floor(Math.random() * quotes.length)
      randomQuote.value = quotes[randomIndex]
    }

    onMounted(() => {
      getRandomQuote()
    })

    return {
      randomQuote,
      getRandomQuote  // 暴露方法给组件实例
    }
  },
  data() {
    return {
      isLoading: false,
      progress: 0,
      progressInterval: null,
      otherRequirements: '' // 初始值
    };
  },
  computed: {
    ...mapState(['story', 'continuationCount']),
    options() {
      return [this.story.options1, this.story.options2];
    }
  },
  methods: {
    ...mapActions(['updateStory', 'incrementContinuationCount']),
    async selectOption(option) {
      if (this.isLoading) return;
      // 新增：每次操作时刷新引用
      this.getRandomQuote();
      this.isLoading = true;
      this.progress = 10;
      this.selectedOption = option;
      // 启动进度模拟
      this.progressInterval = setInterval(() => {
          this.progress = Math.min(this.progress + 15, 85);
        }, 800);
      console.log('continuationCount的数值:',this.continuationCount);
      if (this.continuationCount >= 8 && !this.$store.state.isGeneratingEnd) {  
        this.$store.dispatch('setIsGeneratingEnd', true); // 设置标志位                     //################################ 控制交互轮次
        try {
          const currentRequirements = this.otherRequirements;
          // console.debug('生成结局currentRequirements:', error);
          const response = await generateStoryEnd({ 
            end_requirements: currentRequirements || '',
            choice: option.toString(),
          });
          console.debug('完成generateStoryEnd得到结局数据 response');
          this.updateStory(response);
          
          // this.$store.commit('setStory', response); // 将数据提交到 Vuex 状态
          this.otherRequirements = '';
          // 确认Vuex更新后跳转
          console.debug('将结局数据提交到 Vuex');
          await this.$nextTick(); // 确保DOM和状态更新
          console.debug('确认将结局数据提交到 Vuex');
          this.$router.push({ path: '/end', query: { isGeneratingEnd: true } });
        } catch (error) {
          console.error('生成结局错误:', error);
        } finally {
          this.selectedOption = null;
          this.$store.dispatch('resetContinuationCount'); // <-- 新增重置
          this.$store.dispatch('setIsGeneratingEnd', false); // 重置标志位
        }
        return;
      }

      try {
        const currentRequirements = this.otherRequirements;
        const response = await generateStoryContinuation({
          other_requirements: currentRequirements || '',
          choice: option.toString(),
        });

        this.updateStory(response);
        this.incrementContinuationCount();
        this.otherRequirements = '';
        // 完成进度
        this.progress = 100;
        await new Promise(resolve => setTimeout(resolve, 300));
      } catch (error) {
        console.error('延续故事错误:', error);
      } finally {
        clearInterval(this.progressInterval);
        this.isLoading = false;
        this.progress = 0;
        this.selectedOption = null;
      }
    },
  },
};
</script>

<style scoped>
/* 新增上方小字样式 */
.story-header-text {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
  text-align: center; /* 新增居中属性 */
}
.story-header-text p {
  margin: 0;
}
/* 添加进度条样式（与之前相同） */
.progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: rgba(108, 92, 231, 0.1);
  z-index: 9999;
  overflow: hidden;
}
.progress {
  height: 100%;
  background: linear-gradient(90deg, #6c5ce7 0%, #8476f1 100%);
  transition: width 0.3s ease, opacity 0.3s ease;
}
/* 修改加载状态样式 */
.option-button:disabled {
  background-color: transparent !important; /* 关键修改：背景透明 */
  position: relative;
  overflow: hidden;
}
.loading-option {
  position: relative;
}
.loading-option::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8); /* 半透明遮罩 */
  z-index: 1;
}

.option-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  border: 2px solid rgba(108, 92, 231, 0.2); /* 半透明底色 */
  border-top: 2px solid rgba(108, 92, 231, 0.8); /* 半透明主色 */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  z-index: 2; /* 确保在遮罩层上方 */
}
.button-text {
  position: relative;
  z-index: 3; /* 文字保持在最上层 */
  transition: opacity 0.3s ease;
}
.loading-option .button-text {
  opacity: 0.8; /* 文字保持可见 */
}
@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}
/* 优化加载提示 */
.loading-text {
  color: #6c5ce7;
  font-weight: 500;
  margin-top: 1rem;
}

.story-container {
  min-height: 100vh;
  padding: 2rem 1rem;
  background: #f8f9fa;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.story-card {
  max-width: 760px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.story-content {
  padding: 2rem;
}

.story-title {
  font-size: 1.08rem !important;
  color: #2d3436;
  line-height: 1.5;
  margin-bottom: 1.8rem;
  /* text-align: left; */
  font-weight: 400;
  border-left: 4px solid #6c5ce7;
  padding-left: 1rem;
  white-space: pre-line; /* 保留换行符并自动换行 */
  text-align: justify;   /* 两端对齐提升可读性 */
  max-width: 100%;       /* 移动端适配 */
}

/* 移动端适配
@media (max-width: 768px) {
  .story-title {
    font-size: 1rem; //原1.3rem 
  }
} 
*/

.options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.option-button {
  position: relative;
  padding: 1.2rem;
  border: 1px solid #e0e0e0;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-align: left;
}

.option-button:hover {
  border-color: #a66efa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.1);
}

.option-button.selected-option {
  border-color: #6c5ce7;
  background: #f8f5ff;
}

.button-text {
  position: relative;
  z-index: 2;
  color: #2d3436;
  font-size: 1rem;
  line-height: 1.4;
}

.input-container {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.input-label {
  display: block;
  position: relative;
  max-width: 100%;
}

.label-text {
  display: block;
  margin-bottom: 0.8rem;
  color: #666;
  font-size: 0.9rem;
  font-weight: 400;
}

.styled-input {
  width: 91%;
  padding: 0.9rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.25s ease;
  background: white;
}

.styled-input:focus {
  border-color: #6c5ce7;
  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.1);
}

.input-underline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background: #6c5ce7;
  transition: width 0.3s ease;
}

.styled-input:focus ~ .input-underline {
  width: 100%;
}

/* 保持原有加载动画样式 */
.loading-screen {
  text-align: center;
  padding: 4rem 0;
}

.loading-animation {
  display: inline-flex;
  gap: 0.8rem;
}

.loading-dot {
  width: 12px;
  height: 12px;
  background: #6c5ce7;
  border-radius: 50%;
  animation: dot-pulse 1.4s infinite ease-in-out;
}

@keyframes dot-pulse {
  0%, 80%, 100% { 
    transform: scale(0.5);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .story-content {
    padding: 1.5rem;
  }

  .options-grid {
    grid-template-columns: 1fr;
  }

  .option-button {
    padding: 1rem;
  }

  .story-title {
    font-size: 1.3rem;
    padding-left: 0.8rem;
  }
}
</style>